import styled from '@emotion/styled';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { clearSessionCurrencyTypeId, getSessionCurrencyTypeId } from 'app/api/cookie';
import Box from 'app/components/v2/components/Box';
import Link from 'app/components/v2/components/Text/Link';
import Paragraph from 'app/components/v2/components/Text/Paragraph';
import { CurrencyType } from 'app/constants/currency';

// Local Variables
const StyledDiv = styled.div(({ theme }) => ({
  backgroundColor: theme.semanticColors.system_notification_warning,
  padding: theme.spacing,
}));
function handleClickViewAll() {
  clearSessionCurrencyTypeId();
  window.location.reload();
}

// Component Definition
const SessionCurrencyBanner: FC = () => {
  const { t } = useTranslation('components');
  const sessionCurrencyType = getSessionCurrencyTypeId();

  if (!sessionCurrencyType) {
    return null;
  }

  return (
    <StyledDiv>
      <Box
        alignItems="center"
        display="flex"
        justifyContent="center"
      >
        <Paragraph
          fontColor="status_text"
          marginRight={6}
        >
          {t('sessionCurrencyBanner.alert',
            'Viewing {{currency}} Currency Only',
            { currency: CurrencyType[Number(sessionCurrencyType)] })}
        </Paragraph>

        <Link
          fontColor="brand_700"
          onClick={handleClickViewAll}
        >
          {t('sessionCurrencyBanner.viewAll', 'View All')}
        </Link>
      </Box>
    </StyledDiv>
  );
};

export default SessionCurrencyBanner;
